import {
  ThumbUp,
  ThumbDown,
  Cancel,
  CheckCircle,
  Assignment,
  AssignmentAdd,
  Store,
  AddBusiness,
  Receipt,
  Badge,
  Engineering,
  Build,
  Domain,
  DomainAdd,
  Straighten,
  AddBox,
  ShoppingCart,
  AddShoppingCart,
  SyncAlt,
  Balance,
  ReceiptLong,
  Bookmark,
  BookmarkAdd,
  Pallet,
  Inventory,
  Shelves,
  LocalShipping,
  PersonAdd,
  WorkspacePremium,
  LocationPin,
  AddLocationAlt,
  Contacts,
  Edit,
  Visibility,
  Save,
  Delete,
  ArrowBack,
  ArrowForward,
  Feedback,
} from "@mui/icons-material";

export const GenericAdd = AddBox;
export const EditIcon = Edit;
export const ViewIcon = Visibility;
export const SaveIcon = Save;
export const DeleteIcon = Delete;
export const BackIcon = ArrowBack;
export const ForwardIcon = ArrowForward;

export const ApproveIcon = ThumbUp;
export const RejectIcon = ThumbDown;

export const GoodIcon = CheckCircle;
export const BadIcon = Cancel;

export const BOMIcon = Assignment;
export const BOMAddIcon = AssignmentAdd;

export const VendorIcon = Store;
export const VendorAddIcon = AddBusiness;

export const POIcon = ShoppingCart;
export const POAddIcon = AddShoppingCart;
export const POReceiveIcon = Receipt;

export const SOIcon = Bookmark;
export const SOAddIcon = BookmarkAdd;
export const SOFulfillIcon = ReceiptLong;

export const EmployeeIcon = Badge;
export const EmployeeAddIcon = PersonAdd;

export const WorkOrderIcon = Engineering;
export const WorkOrderAddIcon = Build;

export const CustomerIcon = Domain;
export const CustomerAddIcon = DomainAdd;
export const ComplaintIcon = Feedback;

export const UOMIcon = Straighten;

export const InvMovementIcon = SyncAlt;

export const InvBalanceIcon = Balance;

export const ItemIcon = Pallet;

export const LotIcon = Inventory;

export const ShippingIcon = LocalShipping;

export const InvStatusIcon = WorkspacePremium;

export const LocationIcon = LocationPin;
export const LocationAddIcon = AddLocationAlt;

export const UserIcon = Contacts;
